

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    // ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const intematewhiten: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} = {
    "en": {
        "url": "vaginal-bleaching",
        "meta": {
            "title": "Vaginal Bleaching Treatment Dubai | Elite Body Home",
            "description": "Safe and effective vaginal bleaching treatment for intimate skin lightening and rejuvenation. Achieve an even skin tone with our specialized procedures.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/vaginal-bleaching/",
            "og": {
                "title": "Vaginal Bleaching Treatment Dubai | Elite Body Home",
                "description": "Intimate skin lightening treatment for improved confidence and even skin tone",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-53.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Vaginal Bleaching"],
        "hero": {
            "title": "Vaginal Bleaching Treatment Dubai",
            "subtitle": "Intimate Skin Lightening & Rejuvenation",
            "description": "Over the past few years, vaginal bleaching treatment has become increasingly popular among women looking for intimate skin lightening and rejuvenation solutions. Laser vaginal whitening refers to a cosmetic procedure which targets pigmentation in the vaginal area to create an even skin tone. Due to hormonal changes, aging, or simply individual preferences, a number of women have considered vaginal bleaching for aesthetic purposes and to boost their confidence."
        },
        "howItWorks": {
            "title": "Vaginal Bleaching Procedure",
            "description": "This is the process of applying skin-lightening agents to the vagina to decrease the coloration within the intimate area. The treatment is non-invasive, often done in an office, and customized to the individual patient's skin type and concerns."
        },
        "procedureSteps": {
            "heading": "Treatment Process",
            "para": "Our vaginal bleaching procedure involves several careful steps to ensure safety and effectiveness:",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "A detailed consultation is performed to evaluate the patient's skin type, pigmentation concerns, and the desired outcome.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Cleansing",
                    "desc": "The area is then softly scrubbed with a degreasing solution to cleanse, prep and degrease the skin on the vaginal area before the treatment.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "Lightening Agents Application",
                    "desc": "Medical-grade creams, which typically include ingredients such as hydroquinone, kojic acid or natural extracts, are used on the area.",
                    "icon": "fa-solid fa-spray-can"
                },
                {
                    "title": "Aftercare Instructions",
                    "desc": "Aftercare is just as important as the treatment itself. Patients are given instruction sheets on how to moisturize and avoid doing certain things for several months.",
                    "icon": "fa-solid fa-file-medical"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Vaginal Bleaching",
            "subheading": "Enhancing confidence and appearance",
            "para": "There are a number of advantages of vaginal bleaching for individuals who want to improve the appearance of this area:",
            "items": [
                {
                    "title": "Improved Skin Tone",
                    "desc": "Get uniformity and even tone in vaginal area.",
                    "icon": "fa-solid fa-palette"
                },
                {
                    "title": "Boosted Confidence",
                    "desc": "Gain more confidence in intimate situations or when wearing revealing clothing such as swimsuits.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "Non-Invasive",
                    "desc": "It is non-invasive and no downtime is needed so is a safe option for most.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "Tailored Treatments",
                    "desc": "Tailored to individual needs for natural results.",
                    "icon": "fa-solid fa-user-cog"
                }
            ]
        },
        "eligibility": {
            "heading": "Ideal Candidates",
            "subheading": "",
            "para": "Vaginal bleaching is suitable for women who:",
            "items": [
                {
                    "title": "Have Pigmentation Concerns",
                    "desc": "Those with darkened intimate areas due to hormones, aging, or other factors.",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "Seek Aesthetic Improvement",
                    "desc": "Women wanting to enhance the appearance of their intimate area.",
                    "icon": "fa-solid fa-star"
                },
                {
                    "title": "Are In Good Health",
                    "desc": "Generally healthy individuals without active infections or skin conditions.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "Have Realistic Expectations",
                    "desc": "Understanding that results vary based on skin type and pigmentation levels.",
                    "icon": "fa-solid fa-clipboard-check"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparing for Treatment",
            "subheading": "",
            "para": "Preparation helps ensure a safe and effective vaginal bleaching treatment:",
            "items": [
                {
                    "title": "Avoid Shaving or Waxing",
                    "desc": "Avoid hair removal methods at least a week prior to the procedure to avoid irritation.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Stay Hydrated",
                    "desc": "Drink a lot of water to keep your skin hydrated and apply gentle, non-scented lotions in the area.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "Skip Harsh Products",
                    "desc": "Do not use harsh soaps or cleansers containing chemicals in the vaginal area before the treatment.",
                    "icon": "fa-solid fa-soap"
                },
                {
                    "title": "Wear Loose Clothing",
                    "desc": "On treatment day, wear loose and comfy clothing, to prevent rubbing in that area.",
                    "icon": "fa-solid fa-tshirt"
                }
            ]
        },
        "results": {
            "heading": "Expected Results",
            "subheading": "",
            "para": "Vaginal bleaching is effective after one session but you need to manage your expectations regarding timeline and outcomes:",
            "items": [
                {
                    "title": "Gradual Lightening",
                    "desc": "You will have a lighter and more even skin tone in the intimate area after a few sessions.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "Long-Lasting Effects",
                    "desc": "Results last for months with lifestyle maintenance and occasional upkeep sessions.",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "Enhanced Confidence",
                    "desc": "Be more at ease in your own skin, particularly in intimate settings or when wearing revealing clothing.",
                    "icon": "fa-solid fa-smile"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Recommendations",
            "subheading": "",
            "para": "To maintain and prolong your results:",
            "items": [
                {
                    "title": "Follow Instructions",
                    "desc": "Adhere strictly to the aftercare instructions provided by your specialist.",
                    "icon": "fa-solid fa-list-check"
                },
                {
                    "title": "Gentle Cleansing",
                    "desc": "Use mild, fragrance-free cleansers in the treated area.",
                    "icon": "fa-solid fa-pump-soap"
                },
                {
                    "title": "Avoid Irritation",
                    "desc": "Refrain from sexual activity, tight clothing, and vigorous exercise as advised.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Schedule Follow-ups",
                    "desc": "Attend recommended follow-up sessions for maintenance.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "Is vaginal bleaching safe?",
                    "answer": "When performed by qualified professionals using medical-grade products, vaginal bleaching is considered safe with minimal risks."
                },
                {
                    "question": "How many sessions will I need?",
                    "answer": "Most patients see results after 1-2 sessions, with optimal results typically achieved after 3-5 treatments spaced 2-4 weeks apart."
                },
                {
                    "question": "Does the treatment hurt?",
                    "answer": "Most patients report minimal discomfort during the procedure, often describing it as a mild tingling sensation."
                },
                {
                    "question": "How long do results last?",
                    "answer": "Results can last several months to a year, with maintenance sessions recommended every 6-12 months."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Possible temporary side effects may include mild redness or sensitivity, which typically resolves within 24-48 hours."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Bannerrr-Image-scaled.jpg",
            "beforeAfter": []
        },
        "product": {
            "id": 9,
            "title": "Vaginal Bleaching Treatment in Dubai",
            "description": "Safe and effective intimate skin lightening treatment for improved confidence and even skin tone.",
            "price": 899
        }
    },
    "ar": {
        "url": "vaginal-bleaching",
        "meta": {
            "title": "تبييض المهبل في دبي | ايليت بودي هوم",
            "description": "علاج آمن وفعال لتفتيح المناطق الحساسة وتوحيد لون البشرة في المنطقة الحميمية باستخدام أحدث التقنيات الطبية.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/vaginal-bleaching",
            "og": {
                "title": "تبييض المهبل في دبي | ايليت بودي هوم",
                "description": "علاج تفتيح المناطق الحساسة لتحسين الثقة بالنفس وتوحيد لون البشرة",
                "image": "https://www.elitebodyhome.com/images/vaginal-bleaching-og.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "تبييض المهبل"],
        "hero": {
            "title": "تبييض المهبل في دبي",
            "subtitle": "تفتيح وتجديد البشرة في المناطق الحساسة",
            "description": "أصبح تفتيح المناطق الحساسة من الإجراءات التجميلية الشائعة لدى النساء اللواتي يرغبن في تفتيح لون الجلد وتجديده. يهدف هذا الإجراء التجميلي إلى معالجة تصبغات البشرة في منطقة المهبل، مما يساعد على توحيد لون الجلد وتحسين مظهره بشكل ملحوظ، سواء كان السبب تغيرات هرمونية، أو التقدم في العمر، أو مجرد رغبة شخصية، تلجأ العديد من النساء إلى توريد المنطقة الحميمية لأسباب جمالية ولتعزيز ثقتهن بأنفسهن."
        },
        "howItWorks": {
            "title": "خطوات الإجراء",
            "description": "يتم تبييض المنطقة الحساسة من خلال استخدام مستحضرات طبية مخصصة لتفتيح البشرة وتقليل التصبغات في المناطق الحساسة. تُعد هذه التقنية غير جراحية، وتُجرى في بيئة طبية آمنة، مع تخصيص العلاج حسب نوع البشرة واحتياجات كل سيدة."
        },
        "procedureSteps": {
            "heading": "خطوات العلاج",
            "para": "يتضمن إجراء تبييض المنطقة الحساسة عدة خطوات لضمان السلامة والفعالية:",
            "steps": [
                {
                    "title": "استشارة الطبيب",
                    "desc": "تبدأ الجلسة باستشارة شاملة لتقييم نوع البشرة، وشدة التصبغات، والنتائج المطلوبة، وذلك لوضع خطة علاجية مناسبة.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "التنظيف",
                    "desc": "تُنظف المنطقة بلطف لتحضير البشرة لاستخدام علاج التفتيح.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "وضع مواد التفتيح",
                    "desc": "تُستخدم كريمات طبية تحتوي على مكونات فعالة مثل الهيدروكينون، أو حمض الكوجيك، أو مستخلصات طبيعية للمساعدة على تفتيح البشرة بأمان وفاعلية.",
                    "icon": "fa-solid fa-spray-can"
                },
                {
                    "title": "إرشادات العناية بعد العلاج",
                    "desc": "تُعد الرعاية بعد الجلسة ضرورية للحصول على أفضل النتائج. يتم تزويد المريضات بإرشادات واضحة حول الترطيب المناسب وضرورة تجنب بعض الأنشطة.",
                    "icon": "fa-solid fa-file-medical"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد العلاج",
            "subheading": "تعزيز الثقة وتحسين المظهر",
            "para": "يوفر تبييض المنطقة الحساسة العديد من الفوائد للنساء الراغبات في تحسين مظهر هذه المنطقة من الجسم:",
            "items": [
                {
                    "title": "توحيد لون البشرة",
                    "desc": "يساعد على الحصول على لون بشرة موحد وأفتح في منطقة المهبل.",
                    "icon": "fa-solid fa-palette"
                },
                {
                    "title": "تعزيز الثقة بالنفس",
                    "desc": "يشعر العديد من النساء براحة وثقة أكبر في اللحظات الحميمة أو عند ارتداء الملابس المكشوفة مثل ملابس السباحة.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "إجراء غير جراحي",
                    "desc": "يُعد علاج غير جراحي ولا يتطلب وقتًا للتعافي، مما يجعله خيارًا آمنًا ومناسبًا لمعظم النساء.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "خطط علاجية مخصصة",
                    "desc": "يُصمم العلاج بما يتناسب مع نوع البشرة واحتياجات كل سيدة، لضمان نتائج طبيعية ومتناسقة.",
                    "icon": "fa-solid fa-user-cog"
                }
            ]
        },
        "eligibility": {
            "heading": "المرشحات المناسبات للعلاج",
            "subheading": "",
            "para": "يناسب علاج تبييض المنطقة الحساسة النساء اللواتي:",
            "items": [
                {
                    "title": "يعانين من تصبغات جلدية",
                    "desc": "اللواتي يعانين من اسمرار في المنطقة الحميمية بسبب عوامل هرمونية أو التقدم في العمر.",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "يرغبن في تحسين المظهر",
                    "desc": "السيدات الراغبات في تحسين مظهر المنطقة الحساسة لأسباب جمالية.",
                    "icon": "fa-solid fa-star"
                },
                {
                    "title": "يتمتعن بصحة جيدة",
                    "desc": "النساء اللواتي لا يعانين من التهابات أو مشكلات جلدية نشطة.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "يمتلكن توقعات واقعية",
                    "desc": "يفهمن أن النتائج تختلف حسب نوع البشرة ودرجة التصبغ.",
                    "icon": "fa-solid fa-clipboard-check"
                }
            ]
        },
        "preparationTips": {
            "heading": "التحضيرات قبل الجلسة",
            "subheading": "",
            "para": "يُعد التحضير خطوة أساسية لضمان سلامة وفاعلية علاج تفتيح المنطقة الحميمة:",
            "items": [
                {
                    "title": "تجنبي إزالة الشعر بالحلاقة أو الشمع",
                    "desc": "امتنعي عن إزالة الشعر لمدة لا تقل عن أسبوع قبل الجلسة، لتفادي تهيج البشرة.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "احرصي على ترطيب الجسم",
                    "desc": "اشربي كميات كافية من الماء واعتني بترطيب المنطقة باستخدام مستحضرات لطيفة وخالية من العطور.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "تجنبي المنتجات القاسية",
                    "desc": "لا تستخدمي صابون قاسي أو غسول كيميائي في المنطقة الحساسة قبل العلاج.",
                    "icon": "fa-solid fa-soap"
                },
                {
                    "title": "ارتدي ملابس واسعة",
                    "desc": "اختاري ملابس مريحة وفضفاضة في يوم الجلسة، لتجنب الاحتكاك في المنطقة المعالجة.",
                    "icon": "fa-solid fa-tshirt"
                }
            ]
        },
        "results": {
            "heading": "النتائج المتوقعة",
            "subheading": "",
            "para": "يقدم علاج تفتيح المنطقة الحساسة نتائج واضحة وملموسة، ولكن يجب امتلاك توقعات واقعية من حيث مدة العلاج والنتائج النهائية:",
            "items": [
                {
                    "title": "تفتيح تدريجي",
                    "desc": "ستلاحظين تحسن تدريجي في لون البشرة بعد عدة جلسات، مع توحد أكبر في لون المنطقة الحميمية.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "نتائج تدوم طويلًا",
                    "desc": "تدوم النتائج عادةً لعدة أشهر، خاصةً مع الالتزام بالعناية والجلسات الداعمة عند الحاجة.",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "تعزيز الثقة بالنفس",
                    "desc": "اشعري براحة أكبر في بشرتك، خاصة في اللحظات الحميمة أو عند ارتداء الملابس المكشوفة.",
                    "icon": "fa-solid fa-smile"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح ما بعد العلاج",
            "subheading": "",
            "para": "للمحافظة على النتائج وإطالة أمدها:",
            "items": [
                {
                    "title": "اتباع التعليمات",
                    "desc": "التزمي بدقة بتعليمات ما بعد العلاج التي يقدمها الأخصائي.",
                    "icon": "fa-solid fa-list-check"
                },
                {
                    "title": "تنظيف لطيف",
                    "desc": "استخدمي غسول لطيف وخالي من العطور في المنطقة المعالجة.",
                    "icon": "fa-solid fa-pump-soap"
                },
                {
                    "title": "تجنب المهيجات",
                    "desc": "امتنعي عن العلاقة الحميمة وارتداء الملابس الضيقة والتمارين القوية حسب التوصيات.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "حجزي جلسات المتابعة",
                    "desc": "احرصي على حضور جلسات المتابعة الموصى بها للعناية المستمرة.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "هل تبييض المنطقة الحساسة آمن؟",
                    "answer": "نعم، عند إجرائه من قبل متخصصين مؤهلين باستخدام منتجات طبية معتمدة، يعتبر التبييض آمنًا مع مخاطر محدودة."
                },
                {
                    "question": "كم جلسة أحتاج للحصول على النتائج؟",
                    "answer": "معظم المريضات يلاحظن النتائج بعد 1-2 جلسة، مع تحقيق النتائج المثالية عادةً بعد 3-5 جلسات بفاصل 2-4 أسابيع."
                },
                {
                    "question": "هل العلاج مؤلم؟",
                    "answer": "معظم المريضات يذكرن شعورًا بسيطًا بعدم الراحة أثناء الإجراء، غالبًا ما يوصف كوخز خفيف."
                },
                {
                    "question": "كم تدوم النتائج؟",
                    "answer": "يمكن أن تدوم النتائج عدة أشهر إلى سنة، مع توصية بجلسات صيانة كل 6-12 شهرًا."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "قد تشمل الآثار الجانبية المؤقتة احمرارًا خفيفًا أو حساسية، والتي تختفي عادةً خلال 24-48 ساعة."
                }
            ]
        }
    }
}